import {
  useQuery,
} from 'react-query';

import { useMiddleman } from '@hubins/middleman';

export const useBankIdHistory = (ssn: string) => useQuery(['bankIdHistory', ssn], () => {
  return middleman.get(`/ql/crm/bankid/${ssn}`).then(res => res.data);
}, {
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  refetchOnReconnect: false,
});